import { useQuery } from "@tanstack/react-query";
import { useFilters } from "@/context/FilterContext";
import api from "@/lib/api";

export const useAnalytics = (key, path, extraParams = {}) => {
  const { params } = useFilters();
  const merged = { ...params, ...extraParams };
  const qs = new URLSearchParams(merged).toString();
  return useQuery({
    queryKey: [key, merged],
    queryFn: async () => (await api.get(`${path}${qs ? "?" + qs : ""}`)).data,
  });
};
